module.exports = __webpack_public_path__ + "static/media/profile-style-img3.40e6b5dc.png";